import axios from "axios";

export async function getIp() {

  const response = await axios.get("https://api.ipify.org/");

  return response.data;
}

